import { isUtilityEvChargingOfferRebate } from 'site-modules/shared/components/incentives/incentives-wizard/utils/is-utility-ev-charging-offer-rebate';

export function getUtilityEvChargingOfferRebates(incentives) {
  return incentives.filter(isUtilityEvChargingOfferRebate);
}
